import React, { useState, useEffect } from "react";
import { GET_API_URLS } from "../../../../utils/constant";
import jwtInterceoptor from "../../../../api/jwtInterceptor";
import { Loader, PromotionCard } from "../../../../components/ui";
import { useAuth } from "../../../../context/AuthProvider";
import styles from "./style.module.scss";

const WebPromotions = () => {
  const [activeCategory, setActiveCategory] = useState(null);
  const [currentCategoryPromotions, setCurrentCategoryPromotions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [listLoading, setListLoading] = useState(false);
  const [error, setError] = useState(false);
  const { auth, setAuth } = useAuth();

  useEffect(() => {
    // Getting Promotions Categories List from BE
    jwtInterceoptor
      .get(GET_API_URLS.WEB_PROMOTIONS_CATEGORY)
      .then((response) => {
        setAuth((prev) => ({ ...prev, webPromotionsCategory: response.data }));
        if (!response.data?.length) setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response?.status === 403) {
          setError("You dont have permission to access this page.");
        } else {
          setError("There was a problem while loading the data.");
        }
        console.log("Error", error);
      });
  }, [setAuth]);

  // Set first category from BE when categories are loaded (for initial display)
  useEffect(() => {
    if (auth.webPromotionsCategory?.length && activeCategory === null) {
      const firstCategoryId = auth.webPromotionsCategory[0].id;
      setActiveCategory(firstCategoryId);
      setLoading(false);
    }
  }, [auth.webPromotionsCategory, activeCategory]);

  // Fetch promotions only when a category is selected (first category on load, or on tab click)
  useEffect(() => {
    if (activeCategory === null) return;
    setListLoading(true);
    jwtInterceoptor
      .get(GET_API_URLS.WEB_PROMOTIONS, {
        params: { category: activeCategory },
      })
      .then((response) => {
        const data = Array.isArray(response.data) ? response.data : [response.data];
        const sorted = [...data].sort(
          (a, b) => (a.sequence_number || 0) - (b.sequence_number || 0)
        );
        setCurrentCategoryPromotions(sorted);
      })
      .catch((error) => {
        if (error.response?.status === 403) {
          setError("You dont have permission to access this page.");
        } else {
          setError("There was a problem while loading the data.");
        }
        console.log("Error", error);
      })
      .finally(() => {
        setListLoading(false);
      });
  }, [activeCategory]);

  if (loading) {
    return (
      <div className={styles.loadingPage}>
        <Loader />
      </div>
    );
  }

  return (
    <div className={styles.webPromotionPage}>
      {error ? (
        <h3 style={{ textAlign: "center" }}>{error}</h3>
      ) : (
        <>
          <div className={styles.webPromotionCategory}>
            {auth?.webPromotionsCategory?.map((val, i) => (
              <div key={val.id}>
                <button
                  type="button"
                  className={
                    activeCategory === val.id
                      ? styles.activeButton
                      : styles.categoryBtn
                  }
                  onClick={() => setActiveCategory(val.id)}
                >
                  <span>{val.name}</span>
                </button>
              </div>
            ))}
          </div>

          <div className={styles.promotionBlock}>
            {listLoading ? (
              <Loader />
            ) : currentCategoryPromotions?.length > 0 ? (
              currentCategoryPromotions.map((val, i) => (
                <PromotionCard
                  id={val.id}
                  image={val.image}
                  title={val.name}
                  startDate={val.effective_date}
                  endDate={val.expiration_date}
                  data={{ ...val, category: val.category?.id ?? activeCategory }}
                  key={val.id}
                  sequenceNumber={val.sequence_number}
                />
              ))
            ) : (
              <div>
                <h2 style={{ textAlign: "center" }}>No Web Promotions</h2>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default WebPromotions;
